module.exports = __webpack_public_path__ + "img/lg_ring_r_o_1_1@2x.7808b588.png";